<template>
  <div ref="wissel" id="knd-wissel" class="knd-wissel">
    <div class="knd-wissel-container">
        <swiper
          :slides-per-view="1"
          :effect="'cube'"
          spaceBetween={0}
          :autoHeight= "true"
          :allowTouchMove="false"
          :cubeEffect="{
            shadow: false,
            slideShadows: false
          }"
          :speed="1000"
          :space-between="0"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide>
            <div class="swiper-wissel">
              <Chat :content="chatContent" :simulate="false" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <Operator :content="content"  />
          </swiper-slide>
        </swiper>
      </div>


      <div class="knd-stepper">
        <div class="knd-stepper__inner knd-wrapper__sm">
          Je gaat nu aan de slag als chatoperator. 
          Kies het beste antwoord op de berichten van {{$store.state.user.name}}. 
          Daarna leggen we uit welke tactiek wordt ingezet.
        </div>
      </div>
  </div>
</template>
<script>
  // Import Swiper Vue.js components
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import SwiperCore, { EffectCube, EffectFlip } from "swiper";
  import enterView from 'enter-view';

  import Chat from './chat/user.vue';
  import Operator from './chat/operator.vue';
  import {sleep} from "../utils/main";

  // Import Swiper styles
  import 'swiper/swiper-bundle.min.css'
  import 'swiper/swiper.min.css'

  SwiperCore.use([EffectCube, EffectFlip]);

  export default {
    props: {
      content: {
        type: Object
      }
    },
    components: {
      Swiper,
      SwiperSlide,
      Chat,
      Operator
    },
    computed: {
      paragrafen() {
        return this.$store.state.content.paragrafen;
      }
    }, 

    data: function() {
      return {
        once: false,
        chatContent: {}
      }
    },

    created() {
      let index =  this.paragrafen.findIndex(item => {
        return item.titel === "Chat intro";
      })

      this.chatContent = this.paragrafen[index];
    },

    mounted () {
      this.setEnterView();
    },

    methods: {
      onSwiper(swiper) {
        this.swiper = swiper;
        this.swiper.update();
      },

      onSlideChange(evt){
        // console.log('slide change');
        this.swiper.update();
      },

      setEnterView() {
        let swiper = this.swiper;
        enterView({
          selector: '.knd-stepper',
          enter: async (el) => {
            el.classList.add('entered');
            this.swiper.slideNext();
            this.swiper.update();
          },
          exit: function(el) {
            el.classList.remove('entered');
          },
          offset: .7,
          once: true, // trigger just once
        });
      }
    }
  };
</script>

<style lang="scss">
  .swiper-container-3d {
    // perspective: none !important;
    // transform: translate3d(0,0,0);
  }

  .knd-wissel {
    position: relative;
    .swiper-wissel {
      height: 100vh;
      .knd-chat-user {
        height: 100%;
      }
    }

   .swiper-wissel .chat {
      position:absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100%;
    }
  }

  .knd-wissel-container {
    position: sticky;
    top: 0;
  }

  .knd-stepper {
    padding-bottom: 150vh;
    position: relative;
    z-index: 1000;
    pointer-events: none;
    -webkit-transform: translate3d(0,0,0);

    .knd-stepper__inner {
      background: #FFF;
      border-radius: 2rem;
      padding: 2rem;
    }
  }

</style>